import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';

import { DialogButton } from 'src/components';
import { useFetchStatus } from 'src/hooks';
import { SmaMonitoringPlanForm } from 'src/scenes/Project/scenes/MonitoringPlans/components';


const SmaMonitoringPlanCreateDialog = props => {

  const { actions, options } = props;
  const { sitesOptions } = options;

  const [ monitoringPlanName, setMonitoringPlanName ] = useState('');
  const [ site, setSite ] = useState(null);

  const { fetchStatus, errorMessage, hasBadData, hasError, handleConfirm } = useFetchStatus({
    confirmFn: () => actions.createMonitoringPlan({ name: monitoringPlanName, siteId: site?.value }),
    validationFn: () => hasName,
    closeFn: actions.closeDialog,
  });

  const handleSiteChange = (_, selectedSite) => setSite(selectedSite);
  const handleMonitoringPlanName = value => setMonitoringPlanName(value);

  const hasName = Boolean(monitoringPlanName.trim().length);

  return (
    <>
      <DialogTitle id="form-dialog-title">Crear plan de monitoreo</DialogTitle>
      <DialogContent>
        <SmaMonitoringPlanForm
          options = {{ sitesOptions }}
          validations={{ hasBadData, hasError, hasName, errorMessage }}
          actions={{ handleSiteChange, handleMonitoringPlanName }}
          data={{ monitoringPlanName, site }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={actions.closeDialog} color="secondary">Cancelar</Button>
        <DialogButton fetchStatus={fetchStatus} onClick={handleConfirm} color='primary'>Crear</DialogButton>
      </DialogActions>
    </>
  );
};

SmaMonitoringPlanCreateDialog.propTypes = {
  actions: PropTypes.object.isRequired,
  options: PropTypes.shape({
    sitesOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })),
  }),
};


export {
  SmaMonitoringPlanCreateDialog,
};
